import { debounce } from 'lodash-es';
import Component from 'navigation/component/Component';
import capency from 'helpers/capency';
import browser from 'helpers/browser';
import validators from '../form/components/validators';
class CapencyField extends Component {
    streetInput;
    streetField;
    suggestionsDiv;
    suggestions;
    // add missing types
    _loading;
    focused;
    country;
    get loading() {
        return this._loading;
    }
    set loading(value) {
        this.streetInput.parentElement.classList.toggle('loading', value);
        this._loading = value;
    }
    constructor(el, refs) {
        super(el);
        this.parseForm();
    }
    initialized() {
        super.initialized();
    }
    parseForm() {
        this.streetInput = this.el;
        this.streetField = this.streetInput.parentElement.parentElement;
        this.streetField.classList.add('with-suggestions');
        this.suggestionsDiv = document.createElement('div');
        this.suggestionsDiv.className = 'field__suggestions';
        this.streetField.appendChild(this.suggestionsDiv);
    }
    bindEvents(add = true) {
        const method = add ? 'addEventListener' : 'removeEventListener';
        this.el[method]('focusin', this.onInputOrFocus);
        this.el[method]('blur', this.focusOut);
        this.streetInput[method]('input', this.onInputOrFocus);
    }
    focusOut = (event) => {
        this.focused = false;
        setTimeout(() => {
            this.suggestionsDiv.classList.remove('opened');
        }, 200);
    };
    onInputOrFocus = (event) => {
        const search = this.streetInput.value;
        this.focused = true;
        if (event.inputType !== undefined)
            this.emit('input');
        if (this.suggestions)
            this.suggestionsDiv.classList.toggle('opened', true);
        if (event.inputType === 'insertText') {
            if (search && search.length > 5) {
                this.loading = true;
                this.capencySearch(search);
            }
            else {
                this.loading = false;
            }
        }
    };
    capencySearch = debounce(async (query) => {
        const request = await capency.searchAddress(query, this.country);
        const response = await request.json();
        if (response.body?.addresses)
            this.updateCapencySuggestions(response.body?.addresses.address.sort((a, b) => parseInt(a.qualityCode) - parseInt(b.qualityCode)));
        this.loading = false;
    }, 500);
    clearSuggestions() {
        browser.waitRepaint(() => {
            this.suggestions && this.suggestions.forEach((div) => {
                div.removeEventListener('click', this.onSuggestionClick);
            });
            this.suggestions = null;
        });
    }
    updateCapencySuggestions(suggestions) {
        if (!suggestions)
            return;
        // this.clearSuggestions()
        this.suggestionsDiv.classList.toggle('opened', this.focused);
        this.suggestionsDiv.innerHTML = '';
        this.suggestions = suggestions.map((suggestion) => {
            const { streetName, streetNumber, postalCode, locality, buildingName } = suggestion;
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'field__suggestion';
            const label = `${streetNumber || ''} ${streetName || ''}, ${postalCode || ''} ${locality || ''}`;
            const description = buildingName ? `${buildingName}` : '';
            suggestion.label = label;
            suggestion.description = description;
            button.setAttribute('data-info', JSON.stringify(suggestion));
            button.addEventListener('click', this.onSuggestionClick);
            let alreadyTyped = this.el.value;
            let remaining;
            if (label.toLowerCase().includes(alreadyTyped.toLowerCase())) {
                remaining = label.slice(alreadyTyped.length);
            }
            else {
                remaining = label;
                alreadyTyped = '';
            }
            button.innerHTML = `
        <h5 class="field__suggestion-title"><span class="field__suggestion__already-typed">${alreadyTyped}</span>${remaining}</h5>
        ${description ? `<p class="field__suggestion-description">${description}</p>` : ''}
      `;
            this.suggestionsDiv.appendChild(button);
            return button;
        });
    }
    onSuggestionClick = (event) => {
        const info = JSON.parse(event.currentTarget.getAttribute('data-info'));
        this.emit('select', this.extractCapencyAddress(info));
        this.updateCapencySuggestions();
        browser.waitRepaint(() => {
            this.suggestionsDiv.classList.toggle('opened', false);
            this.streetInput.blur();
        });
        this.loading = false;
    };
    extractCapencyAddress = (addressInfo) => {
        const object = {};
        const { streetName, streetNumber, postalCode, locality, buildingName, countryCode } = addressInfo;
        if (!object.address || !validators.street.isValidSync(object.address)) {
            if (streetName && streetNumber)
                object.address = `${streetNumber} ${streetName}`;
            else if (streetName)
                object.address = streetName;
        }
        object.address2 = buildingName || null;
        object.city = locality;
        object.country = countryCode.slice(0, 2);
        object.postcode = postalCode;
        object.phone_code = object.country;
        return object;
    };
    flush() {
        this.clearSuggestions();
        super.flush();
    }
}
export default CapencyField;
